import { PieChartModel } from '../models/chart/pie-chart.model';
import { ChartStylingModel } from '../models/chart/chart-styling.model';

export const /** @type {?} */ PieChartTemplates = {
  defaultTemplate: {
    property: new PieChartModel({
      display: true,
      disable: false,
      donut: false,
      showLabels: true,
      explodeSlices: false,
      gradient: false,
      showLegend: true,
      legendPosition: 'right',
      chartAlignment: 'start',
      colorSchemeName: 'forest',
      colorScheme: {
        domain: []
      },
      showXAxis: true,
      showYAxis: true,
      showXAxisLabel: true,
      showYAxisLabel: true,
      xAxisLabel: '',
      yAxisLabel: '',
    }),
    style: new ChartStylingModel({
      barsContainerWidth: '100%',
      barsContainerHeight: '200px'
    })
  }
}
